export default __webpack_public_path__ + "assets/products/product-breakfast.fcf9ce20d20ab870b09d56ea528c97e0.webp";